/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable max-len */
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { Input, Button, Text, Link, OffersIcon, PhoneIcon } from '@beef/ui-kit';

import { sendCheaperOptionThunk } from 'store/ProductDetails/cheaperOption/actions';
import { useInput } from 'utils/customHooks/useInput';
import { getIsEmailValid, getTelNumberValue } from 'utils/validation';

import styles from './styles.pcss';

const cx = classNames.bind({ ...styles });

const getIsValidTelNumber = (value) => getTelNumberValue(value).length === 11;
const getIsEmptyString = (value) => value.length !== 0;

const INPUTS_NAMES = {
  EMAIL: 'EMAIL',
  PHONE: 'PHONE',
  LINK: 'LINK',
  PRICE: 'PRICE',
};

const INVALID_FIELDS = {
  [INPUTS_NAMES.EMAIL]: 'Неверный формат e-mail',
  [INPUTS_NAMES.PHONE]: 'Введите номера телефона',
  [INPUTS_NAMES.LINK]: 'Укажите ссылку на товар',
  [INPUTS_NAMES.PRICE]: 'Укажите цену',
};

const ISVALID_CALLBACKS = {
  [INPUTS_NAMES.EMAIL]: getIsEmailValid,
  [INPUTS_NAMES.PHONE]: getIsValidTelNumber,
  [INPUTS_NAMES.LINK]: getIsEmptyString,
  [INPUTS_NAMES.PRICE]: getIsEmptyString,
};

export const CheaperForm = ({ isOpen, texts, article, isSending }) => {
  const dispatch = useDispatch();
  const [isList, setIsList] = useState(false);

  const [emailInput, phoneInput, linkInput, priceInput] = Object.keys(INPUTS_NAMES).map((id) =>
    useInput({
      id,
      initialState: '',
      errorText: INVALID_FIELDS[id],
      invalidHandler: ISVALID_CALLBACKS[id],
    }),
  );
  const onSetList = useCallback(() => {
    setIsList(!isList);
  }, [isList]);

  const submitHandler = useCallback(
    (event) => {
      event.preventDefault();

      const inputs = [emailInput, phoneInput, linkInput, priceInput];
      const invalidInputs = inputs.filter((input) => !input.isValid);

      if (invalidInputs.length > 0) {
        invalidInputs.forEach((input) => {
          input.setErrorMessage(INVALID_FIELDS[input.id]);
        });

        return;
      }

      const price = Number(priceInput.value.replace(/[^0-9]/g, ''));
      // убрать код страны
      const phone = getTelNumberValue(phoneInput.value).slice(1, 11);

      const option = {
        article,
        price,
        phone,
        link: linkInput.value,
        email: emailInput.value,
      };

      dispatch(sendCheaperOptionThunk(option));
    },
    [emailInput, phoneInput, linkInput, priceInput, article],
  );

  useEffect(() => {
    if (!isOpen) {
      const inputs = [emailInput, phoneInput, linkInput, priceInput];

      inputs.forEach((input) => {
        input.setValue('');
      });
    }
  }, [isOpen]);

  const shopList = texts?.shop_list ?? '';
  const str = shopList.split(' ');
  const popped = str.pop();
  const data = str.join(' ').concat(' ');

  const competitors = texts?.competitors ?? [];

  return (
    <form onSubmit={submitHandler} className={cx('form-wrapper')}>
      <div className={cx('caption-wrapper')}>
        <Text size="size2-m">{texts?.title}</Text>
      </div>
      <div className={cx('filds-wrapper')}>
        <div className={cx('input-price')}>
          <Input
            label={texts?.price}
            name="price"
            type="text"
            maskSettings={{
              suffix: '₽',
              thousandSeparator: true,
            }}
            {...priceInput}
          />
        </div>
        <div className={cx('link-wrapper')}>
          <Input label={texts?.url} name="link" type="text" {...linkInput} />
        </div>
        <div className={cx('input-wrapper')}>
          <Input
            label={texts?.Phone_number}
            name="tel"
            type="tel"
            maskSettings={{ mask: '_', format: '+7 (###) ###-##-##' }}
            placeholder="+7 000 000 00 00"
            {...phoneInput}
          />
        </div>
        <div className={cx('input-wrapper')}>
          <Input
            label={texts?.email}
            name="e-mail"
            type="email"
            placeholder="beeline@bee.ru"
            {...emailInput}
          />
        </div>
      </div>
      <div className={cx('text-wrapper')}>
        <div className={cx('icon-wrapper')}>
          <OffersIcon size="s" />
        </div>
        <div className={cx('shop-list-wrapper')}>
          <Text size="size5-r-l">
            {data}
            <b onClick={onSetList} className={cx('shop-list-option')}>
              {popped}
            </b>
          </Text>
        </div>
      </div>
      {isList && (
        <div className={cx('shop-list')}>
          <Text size="size5-r-l">Конкурентами считаются:</Text>
          <ul>
            {competitors.map((competitor) => (
              <li key={competitor}>{competitor}</li>
            ))}
          </ul>
        </div>
      )}
      <div className={cx('text-wrapper')}>
        <div className={cx('icon-wrapper')}>
          <PhoneIcon size="s" />
        </div>
        <Text size="size5-r-l">{texts?.item_approve}</Text>
      </div>
      <div className={cx('caption-form-wrapper')}>
        <Link isNoUnderline target="_blank" href={texts?.promotion_url} size="size5-m">
          {texts?.about}
        </Link>
      </div>
      <div className={cx('send-wrapper')}>
        <Button fullWidth isLoading={isSending} size="l" type="submit" variant="main">
          Отправить
        </Button>
      </div>
    </form>
  );
};

CheaperForm.propTypes = {
  isOpen: PropTypes.bool,
  texts: PropTypes.object,
  article: PropTypes.string,
  isSending: PropTypes.bool,
};
